/* eslint-disable no-nested-ternary */
import * as vp from 'vopay';
import moment from 'moment';
import Lottie from 'lottie-react';
import { FunctionComponent, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useLayout } from '../../../../providers/Layout.provider';
import { useAccountVerification } from '../../../../providers/AccountVerification.provider';
import styles from './VerificationResult.module.scss';
import frenchLocale from '../MomentLocale/fr';
import paymentAnimation from '../../../../../../../component-library/src/components/DataDisplay/Lottie/Paylink_Received.json';
import BrandingLogo from '../../../UI/BrandingLogo/BrandingLogo';

const { Title, Icon, Box } = vp;

const lottieStyle = {
  width: 200,
  height: 200,
};

type FC = FunctionComponent;

const VerificationResult: FC = () => {
  const { Status } = useParams<{ Status: string }>();
  const { brandingInfo } = useAccountVerification();
  const { setLayoutInfo } = useLayout();
  const { t, i18n } = useTranslation('translations', { keyPrefix: 'VerificationResult' });
  useEffect(() => {
    frenchLocale();
    setLayoutInfo(
      vp.chooseColor<string | null | undefined>('#FFD147', brandingInfo?.BrandingDetails?.PrimaryColor),
      'moon',
      '',
      80,
      20,
      0,
      false,
      true,
    );
  }, [brandingInfo]);

  useEffect(() => {
    moment.locale(i18n.language !== 'en' ? 'fr' : 'en');
  }, [i18n.language]);

  return (
    <div className={styles.thanksRightContainer}>
      {Status === 'verified' && (
        <Box maxwidth="500px" flx="col" height="auto">
          {brandingInfo?.Logo && (
            <Box jc="center" pb="md">
              <BrandingLogo src={brandingInfo?.Logo} />
            </Box>
          )}
          <Box jc="center">
            <Lottie animationData={paymentAnimation} loop style={lottieStyle} height={50} />
          </Box>
          <div className={styles.resultTitle}>
            <Title title={`${t('thankYou')}`} textSize="35px" bold />
          </div>
          <div className={styles.thanksMSGContainer}>{t('verificationVerifiedMessage')}</div>
        </Box>
      )}
      {Status === 'failed' && (
        <Box maxwidth="500px" flx="col" gap="common" height="auto">
          <div className={styles.failIconContainer}>
            <Icon icon="fail3" color="none" width="70px" height="70px" />
          </div>
          <Title title={`${t('verificationFailed')}`} textSize="35px" bold />
          <div className={styles.description}>{`${t('verificationFailedMessage')}`}</div>
        </Box>
      )}
      {Status === 'expired' && (
        <Box maxwidth="500px" flx="col" gap="common" height="auto">
          <Title title={`${t('verificationExpired')}`} textSize="35px" bold />
          <div className={styles.description}>{`${t('verificationExpiredMessage')}`}</div>
        </Box>
      )}
      <div className={styles.mobileImage} />
    </div>
  );
};

export default VerificationResult;
